module.exports = __webpack_public_path__ + "static/media/intercom.f1639c5c.svg";